<div>
    <h2 mat-dialog-title>Delete {{ data.accountNumber }}</h2>
    <mat-dialog-content>
      <h4 class="tw-pt-3">Are you sure you want to delete this account?</h4>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button color="primary" mat-dialog-close>No, Cancel</button>
      <button mat-raised-button color="primary" (click)="deleteAccount()">Yes, Delete</button>
    </mat-dialog-actions>
  </div>
